// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  DeckCard,
  ParticipantView,
  VoteResultRecordView,
} from "./types";


export default __t.row({
  code: __t.string(),
  permanent: __t.bool(),
  currentTopic: __t.string().name("current_topic"),
  revealed: __t.bool(),
  get currentDeck() {
    return __t.array(DeckCard).name("current_deck");
  },
  get participants() {
    return __t.array(ParticipantView);
  },
  get voteHistory() {
    return __t.array(VoteResultRecordView).name("vote_history");
  },
  myConnections: __t.array(__t.connectionId()).name("my_connections"),
});
